import { setNotification } from '../../../helpers/notification';

const PARAMETERS = {
  edit: function ({ inputs, parameters, t }) {
    let certificateRepealTime = parameters.find(
      (item) => item.parameterName === 'yekg_certificate_repeal_time'
    );
    let minimumRepealPeriod = parameters.find(
      (item) => item.parameterName === 'minimum_repeal_period'
    );

    if (
      !inputs.parameterValue &&
      !inputs.parameterDecimalValue &&
      !inputs.parameterDateValue
    ) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.parameterValue')
      );
      return false;
    }
    if (
      inputs.parameterName === 'minimum_repeal_period' &&
      parseInt(inputs.parameterValue) >=
        parseInt(certificateRepealTime.parameterValue)
    ) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.repealMin')
      );
      return false;
    }
    if (
      inputs.parameterName === 'yekg_certificate_repeal_time' &&
      parseInt(inputs.parameterValue) <=
        parseInt(minimumRepealPeriod.parameterValue)
    ) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.organizedMinRepeal')
      );
      return false;
    }
    if (!inputs.startDate) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.startDate')
      );
      return false;
    }
    if (!inputs.description) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.description')
      );
      return false;
    }
    if (inputs.description.length < 10) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.descriptionMinCharacter')
      );
      return false;
    }
    return true;
  },
};

const PROCESS = {
  edit: function ({ inputs, process, t }) {
    let sessionTime = process.find(
      (item) => item.processName === 'SESSION_TIME'
    );
    let contractProcessTime = process.find(
      (item) => item.processName === 'CONTRACT_PROCESS_TIME'
    );

    if (!inputs.startHour || inputs.startMinute === '') {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.startTime')
      );
      return false;
    }
    if (!inputs.endHour || inputs.endMinute === '') {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.endTime')
      );
      return false;
    }
    if (
      parseInt(
        `${inputs.endHour}${
          inputs.endMinute.toString().length === 1
            ? `0${inputs.endMinute}`
            : inputs.endMinute
        }`
      ) <
      parseInt(
        `${inputs.startHour}${
          inputs.startMinute.toString().length === 1
            ? `0${inputs.startMinute}`
            : inputs.startMinute
        }`
      )
    ) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.endLessThanStart')
      );
      return false;
    }
    // session time validation
    if (
      inputs.processName === 'CONTRACT_PROCESS_TIME' &&
      parseInt(
        `${inputs.startHour}${
          inputs.startMinute.toString().length === 1
            ? `0${inputs.startMinute}`
            : inputs.startMinute
        }`
      ) <
        parseInt(
          `${sessionTime.startHour}${
            sessionTime.startMinute.toString().length === 1
              ? `0${sessionTime.startMinute}`
              : sessionTime.startMinute
          }`
        )
    ) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.startLessThanSession')
      );
      return false;
    }
    if (
      inputs.processName === 'CONTRACT_PROCESS_TIME' &&
      parseInt(
        `${inputs.endHour}${
          inputs.endMinute.toString().length === 1
            ? `0${inputs.endMinute}`
            : inputs.endMinute
        }`
      ) >
        parseInt(
          `${sessionTime.endHour}${
            sessionTime.endMinute.toString().length === 1
              ? `0${sessionTime.endMinute}`
              : sessionTime.endMinute
          }`
        )
    ) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.endGreaterThanSession')
      );
      return false;
    }
    // post session time validation
    if (
      inputs.processName === 'POST_SESSION_TIME' &&
      parseInt(
        `${inputs.startHour}${
          inputs.startMinute.toString().length === 1
            ? `0${inputs.startMinute}`
            : inputs.startMinute
        }`
      ) !==
        parseInt(
          `${contractProcessTime.endHour}${
            contractProcessTime.endMinute.toString().length === 1
              ? `0${contractProcessTime.endMinute}`
              : contractProcessTime.endMinute
          }`
        )
    ) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.startEqualToSession')
      );
      return false;
    }
    if (
      inputs.processName === 'POST_SESSION_TIME' &&
      parseInt(
        `${inputs.endHour}${
          inputs.endMinute.toString().length === 1
            ? `0${inputs.endMinute}`
            : inputs.endMinute
        }`
      ) <
        parseInt(
          `${sessionTime.endHour}${
            sessionTime.endMinute.toString().length === 1
              ? `0${sessionTime.endMinute}`
              : sessionTime.endMinute
          }`
        )
    ) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.endLessThanSession')
      );
      return false;
    }
    // system time validation
    if (
      inputs.processName === 'SESSION_TIME' &&
      parseInt(
        `${inputs.startHour}${
          inputs.startMinute.toString().length === 1
            ? `0${inputs.startMinute}`
            : inputs.startMinute
        }`
      ) >
        parseInt(
          `${contractProcessTime.startHour}${
            contractProcessTime.startMinute.toString().length === 1
              ? `0${contractProcessTime.startMinute}`
              : contractProcessTime.startMinute
          }`
        )
    ) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.startGreaterThanContract')
      );
      return false;
    }
    if (
      inputs.processName === 'SESSION_TIME' &&
      parseInt(
        `${inputs.endHour}${
          inputs.endMinute.toString().length === 1
            ? `0${inputs.endMinute}`
            : inputs.endMinute
        }`
      ) <
        parseInt(
          `${contractProcessTime.endHour}${
            contractProcessTime.endMinute.toString().length === 1
              ? `0${contractProcessTime.endMinute}`
              : contractProcessTime.endMinute
          }`
        )
    ) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.endLessThanContract')
      );
      return false;
    }
    if (!inputs.description) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.description')
      );
      return false;
    }
    if (inputs.description.length < 10) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.descriptionMinCharacter')
      );
      return false;
    }
    return true;
  },
};
const OFF_DAY = {
  edit: function ({ inputs, offDays, t }) {
    if (!inputs.offDayName) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.offDayName')
      );
      return false;
    }
    if (!inputs.startDate) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.startDate')
      );
      return false;
    }
    if (!inputs.endDate) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.endDate')
      );
      return false;
    }
    return true;
  },
  add: function ({ inputs, offDays, t }) {
    if (!inputs.offDayName) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.offDayName')
      );
      return false;
    }
    if (!inputs.startDate) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.startDate')
      );
      return false;
    }
    if (!inputs.endDate) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.endDate')
      );
      return false;
    }
    let alreadyHaveInRange = offDays.find((item) => {
      let itemStartDate = new Date(item.startDate);
      let itemEndDate = new Date(item.endDate);
      let inputStartDate = new Date(inputs.startDate);
      let inputEndDate = new Date(inputs.endDate);
      return inputStartDate >= itemStartDate && inputEndDate <= itemEndDate;
    });
    if (alreadyHaveInRange) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.alreadyOffDay')
      );
      return false;
    }
    return true;
  },
};
const SESSION = {
  edit: function ({ inputs, t }) {
    if (!inputs.sessionDate) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.organizedMarketDate')
      );
      return false;
    }
    if (!inputs.minimumPrice && inputs.minimumPrice !== 0) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.minPrice')
      );
      return false;
    }
    if (!inputs.maximumPrice) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.maxPrice')
      );
      return false;
    }
    if (parseFloat(inputs.minimumPrice) > parseFloat(inputs.maximumPrice)) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.maxGreaterThanMin')
      );
      return false;
    }
    if (!inputs.status) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.status')
      );
      return false;
    }
    if (!inputs.description) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.description')
      );
      return false;
    }
    if (inputs.description.length < 10) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.descriptionMinCharacter')
      );
      return false;
    }
    return true;
  },
  add: function ({ inputs, t }) {
    if (!inputs.sessionDate) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.organizedMarketDate')
      );
      return false;
    }
    if (!inputs.minimumPrice) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.minPrice')
      );
      return false;
    }
    if (!inputs.maximumPrice) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.maxPrice')
      );
      return false;
    }
    if (!inputs.status) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.status')
      );
      return false;
    }
    return true;
  },
};
const CONTRACT = {
  edit: function ({ inputs, t }) {
    if (!inputs.type) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.resourceType')
      );
      return false;
    }
    if (!inputs.status) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.status')
      );
      return false;
    }
    return true;
  },
  add: function ({ inputs, t }) {
    if (!inputs.type) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.resourceType')
      );
      return false;
    }
    if (!inputs.contractName) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.contractName')
      );
      return false;
    }
    if (!inputs.status) {
      setNotification(
        'error',
        t('pages.default.systemParameters.errors.status')
      );
      return false;
    }
    return true;
  },
};

const REQUEST_VALIDATORS = {
  PARAMETERS: PARAMETERS,
  PROCESS: PROCESS,
  OFF_DAY: OFF_DAY,
  SESSION: SESSION,
  CONTRACT: CONTRACT,
};

export { REQUEST_VALIDATORS };
